export default "__VITE_ASSET__NrzhcjV4__ 500w";